<!-- Items only (used for the infinite scroll load-more indicator) -->
<ng-container *ngIf="itemsOnly; else fullLayout">
  <ng-container *ngTemplateOutlet="layoutContent"></ng-container>
</ng-container>

<ng-template #layoutContent>
  @switch (layout) {
    @case ('table') {
      <div class="table-responsive gung-responsive w-100">
        <table class="table table-striped-mobile">
          <thead>
            <tr>
              <th></th>
              <th>
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-header-text"></span>
                </div>
              </th>
              <th>
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-header-text"></span>
                </div>
              </th>
              <th>
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-header-text"></span>
                </div>
              </th>
              <th>
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-header-text"></span>
                </div>
              </th>
              <th style="min-width: 200px"></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of [1,2,3,4,5,6,7,8]">
              <td>
                <div class="table-image">
                  <div class="placeholder-glow">
                    <div class="placeholder skeleton-image"></div>
                  </div>
                </div>
              </td>
              <td>
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-id"></span>
                </div>
              </td>
              <td>
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-name"></span>
                </div>
              </td>
              <td class="text-nowrap">
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-text"></span>
                </div>
              </td>
              <td>
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-price"></span>
                </div>
              </td>
              <td class="buy-btn">
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-buy-btn"></span>
                </div>
              </td>
              <td>
                <div class="placeholder-glow">
                  <span class="placeholder skeleton-icon"></span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    }
    @case ('list') {
      <div class="card mb-2" *ngFor="let i of [1,2,3,4,5,6]">
        <div class="card-body skeleton-list-card-body">
          <div class="card-title skeleton-list-card-title row">
            <div class="col placeholder-glow d-flex align-items-center gap-2">
              <span class="placeholder skeleton-icon"></span>
              <span class="placeholder skeleton-id"></span>
            </div>
            <div class="col-auto placeholder-glow">
              <span class="placeholder skeleton-action-btn"></span>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-4">
              <div class="pb-1">
                <div class="placeholder-glow mb-1"><span class="placeholder skeleton-label"></span></div>
                <div class="placeholder-glow"><span class="placeholder skeleton-value-long"></span></div>
              </div>
              <div class="pb-1">
                <div class="placeholder-glow mb-1"><span class="placeholder skeleton-label"></span></div>
                <div class="placeholder-glow"><span class="placeholder skeleton-value-long"></span></div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="pb-1">
                <div class="placeholder-glow mb-1"><span class="placeholder skeleton-label"></span></div>
                <div class="placeholder-glow"><span class="placeholder skeleton-value"></span></div>
              </div>
              <div class="pb-1">
                <div class="placeholder-glow mb-1"><span class="placeholder skeleton-label"></span></div>
                <div class="placeholder-glow"><span class="placeholder skeleton-value"></span></div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="pb-1">
                <div class="placeholder-glow mb-1"><span class="placeholder skeleton-label"></span></div>
                <div class="placeholder-glow"><span class="placeholder skeleton-value"></span></div>
              </div>
              <div class="pb-1">
                <div class="placeholder-glow mb-1"><span class="placeholder skeleton-label"></span></div>
                <div class="placeholder-glow"><span class="placeholder skeleton-value"></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @default {
      <lib-filter-list-grid-skeleton></lib-filter-list-grid-skeleton>
    }
  }
</ng-template>

<ng-template #fullLayout>
<!-- Top filters layout -->
<ng-container *ngIf="topFilters; else sidebarLayout">
  <div class="placeholder-glow">
    <!-- Search + view toggles -->
    <div class="d-flex align-items-center gap-2 mb-2">
      <span class="placeholder skeleton-search flex-grow-1"></span>
      <span class="placeholder skeleton-select"></span>
      <span class="placeholder skeleton-select"></span>
      <span class="placeholder skeleton-view-toggles"></span>
    </div>
    <!-- Filter chips row -->
    <!--
    <div class="d-flex align-items-center gap-2 mb-2">
      <span class="placeholder skeleton-chip" *ngFor="let i of [1, 2, 3, 4, 5]"></span>
    </div>
    -->
    <!-- Result count -->
    <!--
    <div class="mb-3">
      <span class="placeholder skeleton-result-count"></span>
    </div>
    -->
  </div>
  <ng-container *ngTemplateOutlet="layoutContent"></ng-container>
</ng-container>

<!-- Sidebar layout -->
<ng-template #sidebarLayout>
  <div class="gung-filters-toggle d-lg-none placeholder-glow">
    <span class="placeholder skeleton-toggle-icon"></span>
  </div>
  <div class="row">
    <!--
    <div class="col-lg-3 d-none d-lg-block">
      <div class="filter-list-skeleton-sidebar placeholder-glow">
        <div class="filter-list-skeleton-filters-header px-4 py-3">
          <span class="placeholder skeleton-icon"></span>
          <span class="placeholder skeleton-filters-title"></span>
        </div>
        <div class="filter-list-skeleton-filter-item px-4 py-3" *ngFor="let i of [1, 2, 3, 4, 5]">
          <span class="placeholder skeleton-chevron"></span>
          <span class="placeholder skeleton-filter-label"></span>
        </div>
      </div>
    </div>
    -->
    <div class="col-12">
      <div class="d-flex align-items-center gap-2 mb-5 placeholder-glow">
        <span class="placeholder skeleton-search flex-grow-1"></span>
        <span class="placeholder skeleton-select"></span>
        <span class="placeholder skeleton-select"></span>
        <span class="placeholder skeleton-view-toggles"></span>
      </div>
      <ng-container *ngTemplateOutlet="layoutContent"></ng-container>
    </div>
  </div>
</ng-template>
</ng-template>